;(function($) {
	const showChar = 50
	let showWords = 25
	let readMore = 'Read More'
	let readLess = 'Close'

	if ($('html').attr('lang') === 'fr-FR') {
		readMore = 'Lire plus'
		readLess = 'Fermer'
	}

	var ellipsestext = '...'
	function readmoreTruncate(str, nowords) {
		return str
			.split(' ')
			.splice(0, nowords)
			.join(' ')
	}

	$('.citoyens__text').each(function() {
		var content = $(this).html()
		if (content.length > showChar) {
			var c = readmoreTruncate(content, showWords)
			var h = content
			var html = `
				<div class="truncate-text" style="display:block">${c}<span class="moreellipses">${ellipsestext}</span>
					<p><a href="#" role="button" class="citoyens__moreless moreless more"><svg class="icon icon-readmore " aria-hidden="true" role="img">
                <use xlink:href="https://imageenvoyee-imagesent.canada-culture.org/wp-content/themes/ccc-imagesent/dist/icons.svg#icon-readmore"></use>
        </svg> ${readMore}</a></p>
				</div>
				<div class="truncate-text" style="display:none">
					${h}<p><a href="#" role="button" class="citoyens__moreless moreless less"><svg class="icon icon-readmore " aria-hidden="true" role="img">
                <use xlink:href="https://imageenvoyee-imagesent.canada-culture.org/wp-content/themes/ccc-imagesent/dist/icons.svg#icon-readmore"></use>
        </svg> ${readLess}</a></p>
				</div>`

			$(this).html(html)
		}
	})

	$('.moreless').click(function(e) {
		e.preventDefault()
		var thisEl = $(this)
		var cT = thisEl.closest('.truncate-text')
		var tX = '.truncate-text'

		if (thisEl.hasClass('less')) {
			cT.prev(tX).toggle()
			cT.toggle()
		} else {
			cT.toggle()
			cT.next(tX).toggle()
		}
		return false
	})
})(jQuery)
